import * as Service from '../loyalty-services';

export default {
  /**
   *
   * @param commit
   * @returns {Promise<void>}
   */
  async fetchAllLevels({ commit }) {
    const response = await Service.getAllLevels();

    commit('setProperty', { property: 'levels', payload: response });
  },

  /**
   *
   * @param dispatch
   * @param payload
   * @returns {Promise<void>}
   */
  async createLevel({ dispatch }, { payload }) {
    await Service.createALevel(payload);

    await dispatch('fetchAllLevels');
  },

  /**
   *
   * @param dispatch
   * @param payload
   * @param levelId
   * @returns {Promise<void>}
   */
  async updateLevel({ dispatch }, { payload, levelId }) {
    await Service.updateLevel(levelId, payload);

    await dispatch('fetchAllLevels');
  },

  /**
   *
   * @param dispatch
   * @param loyaltyId
   * @returns {Promise<void>}
   */
  async deleteLoyaltyLevel({ dispatch }, { loyaltyId }) {
    await Service.deleteLevel(loyaltyId);

    dispatch('fetchItemsByLoyalty', { loyaltyId, page: 1, limit: 20 });
  },

  /**
   *
   * @param commit
   * @param loyaltyId
   * @param page
   * @param limit
   * @returns {Promise<void>}
   */
  async fetchItemsByLoyalty({ commit }, { loyaltyId, page, limit }) {
    const payload = await Service.getItemsByLoyalty(loyaltyId, page, limit);

    commit('setLoyaltyItems', payload);
  },

  /**
   *
   * @param commit
   * @param page
   * @param limit
   * @returns {Promise<void>}
   */
  async fetchAllLoyaltyItems({ commit }, { page, limit }) {
    const payload = await Service.getAllLoyaltyItems(page, limit);

    commit('setLoyaltyItems', payload);
  },

  /**
   *
   * @param dispatch
   * @param loyaltyId
   * @param payload
   * @returns {Promise<void>}
   */
  async createLoyaltyItem({ dispatch }, { loyaltyId, payload }) {
    await Service.createLoyaltyItems(loyaltyId, payload);

    dispatch('fetchItemsByLoyalty', { loyaltyId, page: 1, limit: 20 });
  },

  /**
   *
   * @param dispatch
   * @param loyaltyId
   * @param itemId
   * @returns {Promise<void>}
   */
  async deleteLevelItem({ dispatch }, { loyaltyId, itemId }) {
    await Service.deleteLoyaltyLevelItem(loyaltyId, itemId);

    dispatch('fetchItemsByLoyalty', { loyaltyId, page: 1, limit: 20 });
  },

  /**
   *
   * @param commit
   * @param loyaltyId
   * @param page
   * @param limit
   * @returns {Promise<void>}
   */
  async fetchCustomersByLoyalty({ commit }, { loyaltyId, page, limit }) {
    const payload = await Service.getLoyaltyCustomersByLevel(loyaltyId, page, limit);

    commit('setLoyaltyCustomer', payload);
  },

  /**
   *
   * @param commit
   * @param page
   * @param limit
   * @returns {Promise<void>}
   */
  async fetchAllLoyaltyCustomers({ commit }, { page, limit }) {
    const payload = await Service.getAllLoyaltyCustomers(page, limit);

    commit('setLoyaltyCustomer', payload);
  },


  /**
   *
   * @param dispatch
   * @param payload
   * @returns {Promise<void>}
   */
  async createLoyaltyCustomer({ dispatch }, { payload }) {
    await Service.createLoyaltyCustomers(payload);

    dispatch('fetchCustomersByLoyalty', { loyaltyId: payload.loyalty_level_id, page: 1, limit: 20 });
  },

  /**
   *
   * @param dispatch
   * @param customerId
   * @returns {Promise<void>}
   */
  async deleteLoyaltyCustomer({ dispatch }, { customerId }) {
    await Service.deleteLoyaltyCustomers(customerId);

    dispatch('fetchAllLoyaltyCustomers', { page: 1, limit: 20 });
  },
};
